import { render, staticRenderFns } from "./AsignacionTransportista.vue?vue&type=template&id=3a5156f2&"
import script from "./AsignacionTransportista.vue?vue&type=script&lang=ts&"
export * from "./AsignacionTransportista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports